import React, { useState } from "react";
import TableRow from "./TableRow";

function TableRows({ rows, setTableWidth }) {
  const [selectedRow, setSelectedRow] = useState(null);

  const parseRows = (rows) =>
    Object.keys(rows)
      .filter((key) =>
        ["department", "solver", "submittedBy", "subject", "title", "statusText"].includes(key)
      )
      .map((key) => rows[key]);

  return (
    <tbody>
      {rows.map((row, index) => (
        <TableRow
          key={"rows" + index}
          rows={row}
          data={parseRows(rows[index])}
          setSelectedRow={setSelectedRow}
          setTableWidth={setTableWidth}
          blur={selectedRow && selectedRow !== row.uid}
        />
      ))}
    </tbody>
  );
}
export default TableRows;
